import { useMemo } from 'react';
import { createTour, tour as defaultTour } from '@digiwedge/tour-core';
import { LocalStorageTourStorage } from '@digiwedge/tour-core';
/**
 * Returns the default singleton tour, backed by localStorage.
 * For advanced scenarios, create your own via createTour().
 */
export function useTour() {
    return useMemo(() => {
        try {
            // ensure localStorage is available; no-op on SSR
            void new LocalStorageTourStorage();
        }
        catch {
            // ignore storage errors
        }
        return defaultTour;
    }, []);
}
//# sourceMappingURL=useTour.js.map